{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {},
      "geometry": {
        "coordinates": [
          [
            [
              164.58641832665893,
              -17.87657133931374
            ],
            [
              162.89094513163138,
              -19.324005177435097
            ],
            [
              164.7502836782262,
              -22.01537230834984
            ],
            [
              167.7079664649376,
              -23.57403332109554
            ],
            [
              169.0862692511539,
              -21.63072586573624
            ],
            [
              164.58641832665893,
              -17.87657133931374
            ]
          ]
        ],
        "type": "Polygon"
      }
    }
  ]
}